// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9dcc832","667":"6af10312","977":"c555672a"}[chunkId] + ".chunk.js";
};